




































































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Report243Row } from "../table-data/Report243Row"
import { Classificator } from "../../../common/types/Classificator"
import { Segmentation } from "../../../common/types/roots/fields"
import { makeToast } from "../../../common/utils/otherUtils"
import { Indicator } from "../../../common/types/Indicator"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { cloneDeep } from "lodash"
import {Draggable} from "@/modules/budget/monitoring/reports-constructor/common/types/Draggable";

type Column = keyof Report243Row
interface PaginationPageInfo {
    has_prev_page: boolean
    has_next_page: boolean
    cur_page: string
    prev_page: string | null
    next_page: string | null
    total_page: number
    session_expired?: boolean
}
interface TableField {
    key: string
    active: boolean
    child_list: TableField[]
    parent: TableField | null
    colspan: number
    rowspan: number
}


@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class Report243 extends Vue {

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    public readonly tableData!: Report243Row[]
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]
    @Prop({
        type: Date,
        required: true,
        default: false,
    })
    private readonly dateFrom!: Date
     @Prop({
        type: Date,
        required: true,
        default: false,
    })
    private readonly dateTo!: Date
    @Prop({
        type: Boolean,
        required: true,
        default: false,
    })
    private readonly isTree!: boolean
    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    private readonly byBudgetLevel!: boolean // EAK-1904: первая колонка «Уровень бюджета»
    @Prop({
        type: Boolean,
        required: true,
        default: false,
    })
    private readonly comparePrevYear!: boolean
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly segmentation!: Draggable<Segmentation>[]

    private readonly monthList = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
    public classifications: string[] = []
    public tableFields: TableField[] = []
    public indicators: Indicator[] = []

    public currentPage = 1
    public perPage = 300
    public get visibleRows() {
        return this.tableData.filter(it => it.visible).length
    }
    public get currentItems(): Report243Row[] {
        const indexedPage = this.currentPage - 1
        const startIndex = indexedPage * this.perPage
        const endIndex = startIndex + this.perPage
        return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
    }
    public ready:boolean = false
    public pagination_page_info: PaginationPageInfo| null = null
    private created() {
        const lastRowName = this.tableData[this.tableData.length - 1]?.['name']
        if (lastRowName?.includes('has_next_page')) {
            this.pagination_page_info = JSON.parse(lastRowName)
            this.tableData.pop()
        }
        this.tableCollapse = true
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.handlePageChange(1)
        this.ready = true

    }
    private constructTableFieldsTree(indicators: string[]): TableField[] {
        const tree: TableField[] = []
        const totalParent: TableField = {
            key: 'total',
            active: true,
            child_list: [],
            parent: null,
            colspan: 1,
            rowspan: 1
        }
        if (this.comparePrevYear) {
            for (const k of ['total', 'total_prev', 'deviation_total']) {
                const node: TableField = {
                    key: k,
                    active: true,
                    child_list: [],
                    parent: null,
                    colspan: 1,
                    rowspan: 1
                }
                totalParent.child_list.push(node)
            }
            totalParent.colspan = 3
        }
        tree.push(totalParent)
        for (const month of this.monthList) {
            if (indicators.includes(month)) {
                const parent: TableField = {
                    key: month,
                    active: true,
                    child_list: [],
                    parent: null,
                    colspan: 1,
                    rowspan: 1
                }
                if (this.comparePrevYear) {
                    for (const k of [month, `${month}_prev`, `deviation_${month}`]) {
                        const node: TableField = {
                            key: k,
                            active: true,
                            child_list: [],
                            parent: null,
                            colspan: 1,
                            rowspan: 1
                        }
                        parent.child_list.push(node)
                    }
                    parent.colspan = 3
                }
                tree.push(parent)
            }
        }
        return tree
    }
    private constructTableFields(isOnCreate: boolean) {


        const minMonth = this.dateFrom.getMonth()
        const maxMonth = this.dateTo.getMonth()
        let indicatorsList:string[] = []
        const activeIndicatorsList:string[] = this.propIndicators.filter(it => it.active).map(it => it.key)
        if (this.comparePrevYear && (isOnCreate || (!isOnCreate))) {
            indicatorsList.push('total_prev')
        }
        indicatorsList.push('total')
        if (this.comparePrevYear) {
            indicatorsList.push('deviation_total')
        }
        for (let i = minMonth; i <= maxMonth; i++) {
            if (this.comparePrevYear) {
                indicatorsList.push(`${this.monthList[i]}_prev`)
            }
            indicatorsList.push(this.monthList[i])
            if (this.comparePrevYear) {
                indicatorsList.push(`deviation_${this.monthList[i]}`)
            }
        }
        indicatorsList = indicatorsList.filter(it => activeIndicatorsList.includes(it))
        const classifications:string[] = this.byBudgetLevel ? ['budget_section'] : [];
        for (const c of this.segmentation.filter(it => it.active).map(it => it.value)) {
            if (c === 'REGION') {
                classifications.push('region');
            }
            if (c === 'OKED') {
                classifications.push('oked');
            }
            if (c === 'SENDERBIN') {
                classifications.push('senderbin');
            }
            if (c === 'KBK') {
                for (const e of this.incomes.filter(it => it.active).map(it => it.key)) {
                    classifications.push(e);
                }
            }
        }
        this.classifications = classifications
        this.tableFields = this.constructTableFieldsTree(indicatorsList)
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public async paginate_remote(direction: number = 1) {
        const req: any = {'cur_page': this.pagination_page_info ? this.pagination_page_info.cur_page : null, 'direction': direction}
        const new_table_data: Report243Row[] = await fetch('/api-py/monitoring/reports-constructor/paginate/2-43', {
            method: 'POST',
            body: JSON.stringify(req)
        }).then(res => res.json())
        const lastRowName = new_table_data[new_table_data.length - 1]?.['name']
        if (lastRowName?.includes('has_next_page')) {
            this.pagination_page_info = JSON.parse(lastRowName)
            new_table_data.pop()
        }
        if (this.pagination_page_info && this.pagination_page_info.session_expired) {
            makeToast(this, this.$t('modules.common.attention').toString(), this.tr('toast_cahe_session_expired'), 'warning')
        }
        this.tableData.splice(0)
        for (const d of new_table_data) {
            this.tableData.push(d)
        }
        this.tableCollapse = true
        this.handlePageChange(1)
    }

    public tr(key: string): string {
        const tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.2_43'
        let text = String(this.$t(`${tableTranslationKey}.${key}`))

        if (!text || text === `${tableTranslationKey}.${key}`) {

            const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
            text = String(this.$t(`${translationKey}.${key}`))

            if (!text || text === `${translationKey}.${key}`) {
                text = key
            }
        }
        return text
    }
    public getIndicatorName(key: string): string {
        const year = this.dateTo.getFullYear()
        const year_prev = year - 1
        const indicator = key.replace('_prev', '').replace('deviation_', '')
        let result = this.tr(indicator)
        if (key.includes('deviation_')) {
            result = this.$t('modules.budget_execution_monitoring.reports_constructor.deviation') + ' - ' + result
        }
        if (this.comparePrevYear) {
                if (key.includes('_prev')) {
                result = `${result} - ${year_prev}`
            } else {
                result = `${result} - ${year}`
            }
        }
        return result
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }

    public format(value: any): any {
        if (value == null) {
            return ''
        }
        if (Number(value).isNaN) {
            return value
        }
        return formatDigitsGrouping(value)
    }

    public tableCollapse = false
    public collapse(idx:number, collapse:boolean, collapseAll:boolean = false) {
        const el:Report243Row = this.tableData[idx]
        if (el.hasChild) {
            for (const ch of this.tableData.slice(idx + 1)) {
                if (ch.parent_idx === idx) {
                    ch.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(ch['idx'], collapse, collapseAll)
                        ch.collapse = collapse
                    }
                }

            }
        }
        el.collapse = collapse
    }
    public collapseAll(collapse:boolean) {
        for (const item of this.tableData) {
            if (item.parent_idx === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.idx, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }
}
